import React from 'react';
import {Box} from '~/common/fabric/Card/components/Box/Box';
import {Group} from '~/common/fabric/Card/components/Group/Group';
import {Header} from '~/common/fabric/Card/components/Header/Header';
import {Icons} from '~/common/fabric/Card/components/Icons/Icons';
import {EditBox} from '~/common/fabric/CreateDesign/components/EditBox/EditBox';
import {useStamp} from '~/common/fabric/CreateDesign/components/Stamp/actions/useStamp';
import {Stickers} from '~/common/fabric/CreateDesign/components/Stamp/components/Stickers/Stickers';
import './StampEditor.sass';

export const StampEditor = () => {
  const {stampIcons, onStampChange, selectedStamp} = useStamp();

  return (
    <div className="stamp-editor">
      <EditBox className="stamp-editor__content">
        <Group>
          <Header title="Stamps" />
          <Box>
            <Icons
              icons={stampIcons}
              onClick={onStampChange}
              selectedIcon={selectedStamp?.image}
              square
              height={40}
              width={50}
              className="stamp-editor__content__icons"
            />
          </Box>
        </Group>

        <Group>
          <Header title="Stickers" />
          <Box>
            <Stickers className="stamp-editor__content__icons" />
          </Box>
        </Group>
      </EditBox>
    </div>
  );
};
